import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { navigateToDashboard } from '../../utils/roleNavigation';
import api from '../../services/api';

const ChangePassword = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setSuccessMessage('');
    setErrorMessage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      setErrorMessage('Le nuove password non coincidono.');
      return;
    }

    if (formData.newPassword.length < 6) {
      setErrorMessage('La nuova password deve essere di almeno 6 caratteri.');
      return;
    }

    setLoading(true);
    setErrorMessage('');
    setSuccessMessage('');

    try {
      const response = await api.post('/auth/change-password', {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword
      });

      if (response.data.success) {
        setSuccessMessage('Password modificata con successo!');
        setFormData({ currentPassword: '', newPassword: '', confirmPassword: '' });
      } else {
        setErrorMessage(response.data.message || 'Errore durante il cambio password.');
      }
    } catch (err) {
      const msg = err.response?.data?.message || 'Errore durante il cambio password.';
      setErrorMessage(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleGoBack = () => {
    if (user) {
      navigateToDashboard(navigate, user.role);
    } else {
      navigate('/login');
    }
  };

  return (
    <Container className="py-4">
      <Row className="justify-content-center">
        <Col xs={12} sm={10} md={8} lg={6} xl={5}>
          <Card className="shadow-sm border-0">
            <Card.Header style={{ backgroundColor: '#006e39', color: 'white' }}>
              <h5 className="mb-0">
                <i className="bi bi-shield-lock me-2"></i>
                Modifica Password
              </h5>
            </Card.Header>
            <Card.Body className="p-4">
              {successMessage && (
                <Alert variant="success" onClose={() => setSuccessMessage('')} dismissible>
                  <i className="bi bi-check-circle me-2"></i>
                  {successMessage}
                </Alert>
              )}
              {errorMessage && (
                <Alert variant="danger" onClose={() => setErrorMessage('')} dismissible>
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  {errorMessage}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Password attuale *</Form.Label>
                  <Form.Control
                    type="password"
                    name="currentPassword"
                    value={formData.currentPassword}
                    onChange={handleChange}
                    required
                    placeholder="Inserisci la password attuale"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Nuova password *</Form.Label>
                  <Form.Control
                    type="password"
                    name="newPassword"
                    value={formData.newPassword}
                    onChange={handleChange}
                    required
                    minLength={6}
                    placeholder="Inserisci la nuova password"
                  />
                  <Form.Text className="text-muted">
                    La password deve essere di almeno 6 caratteri.
                  </Form.Text>
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>Conferma nuova password *</Form.Label>
                  <Form.Control
                    type="password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                    placeholder="Conferma la nuova password"
                  />
                </Form.Group>

                <div className="d-flex flex-column flex-sm-row gap-2">
                  <Button
                    type="submit"
                    style={{ backgroundColor: '#006e39', borderColor: '#006e39' }}
                    disabled={loading}
                    className="flex-fill"
                  >
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Salvataggio...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-check-lg me-2"></i>
                        Salva Password
                      </>
                    )}
                  </Button>
                  <Button
                    variant="outline-secondary"
                    onClick={handleGoBack}
                    disabled={loading}
                    className="flex-fill"
                  >
                    <i className="bi bi-arrow-left me-2"></i>
                    Annulla
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ChangePassword;
